import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthenticationGate } from "./PrivateRoute";
import Login from "../pages/Login/Login";
import Home from "../pages/Home/Home";
import { StyleProvider } from "../providers/StyleProvider";
import { AuthProvider } from "../providers/AuthProvider";
import AgentsCategories from "../pages/Agents/AgentsCategories/AgentsCategories";
import Chats from "../pages/Chats/Chats";
import AppHome from "../pages/AppHome/AppHome";
import SectionsArticles from "../pages/Articles/SectionsArticles/SectionsArticles";
import Articles from "../pages/Articles/Articles";
import { ChatsRoute } from "./Modules/ChatsRoute";
import { ArticlesRoute } from "./Modules/ArticlesRoute";
import { AppHomeRoute } from "./Modules/AppHomeRoute";
import { AccessRoute } from "./Modules/AccessRoute";
import { UserRoute } from "./Modules/UserRoute";
import AccessProfilesList from "../pages/Access/AccessProfiles/AccessProfilesList/AccessProfilesList";
import AccessPagesList from "../pages/Access/AccessPages/AccessPagesList/AccessPagesList";
import UsersList from "../pages/Access/Users/UsersList/UsersList";
import ArticlesSubsectionsList from "../pages/Articles/ArticlesSubsectionsList/ArticlesSubsectionsList";
import ChatsList from "../pages/Chats/ChatsList/ChatsList";
import ChatToolsList from "../pages/Chats/ChatsTools/ChatToolsList/ChatToolsList";
import ArticleView from "../pages/Articles/ArticleView/ArticleView";
import CategoryView from "../pages/Articles/CategoryView/CategoryView";
import SectionView from "../pages/Articles/SectionView/SectionView";
import SubsectionView from "../pages/Articles/SubsectionView/SubsectionView";
import ArticlesSearch from "../pages/Articles/ArticlesSearch/ArticlesSearch";
import { ArticleSearchProvider } from "../providers/Articles/ArticlesSearch/ArticlesSearchProvider";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import ChatsFeedbackAnalysis from "../pages/ChatsFeedbackAnalysis/ChatsFeedbackAnalysis";
import Authorization from "../pages/Authorization/Authorization";
import Categories from "../pages/Categories/Categories";
import { AgentsCategoriesProvider } from "../providers/Agents/AgentsCategories/AgentsCategoriesProvider";
import { PaginateProvider } from "../providers/PaginateProvider";
import { SidebarFilterProvider } from "../providers/SidebarFilterProvider";
import Unauthorized from "../pages/Unauthorized/Unauthorized";
import Maintenance from "../pages/Maintenance/Maintenance";
import Page404 from "../pages/Page404/Page404";
import HomeNotice from "../pages/HomeNotice/HomeNotice";
import ChatsTutorial from "../pages/ChatsTutorial/ChatsTutorial";
import { UsersProvider } from "../providers/Access/Users/UsersProvider";
import { FinancialRoute } from "./Modules/FinancialRoute";
import Plans from "../pages/Financial/Plans/Plans";
import Coupons from "../pages/Financial/Coupons/Coupons";
import Subscriptions from "../pages/Financial/Subscriptions/Subscriptions";
import Pricing from "../pages/Pricing/Pricing";
import Payments from "../pages/Financial/Payments/Payments";
import Refunds from "../pages/Financial/Refunds/Refunds";
import General from "../pages/Profile/General/General";
import Account from "../pages/Profile/Account/Account";
import Privacy from "../pages/Profile/Privacy/Privacy";
import Devices from "../pages/Profile/Devices/Device";
import Use from "../pages/Profile/Use/Use";
import { UseProvider } from "../providers/Profile/Use/UseProvider";
import { PricingRoute } from "./Modules/PricingRoute";
import { CheckoutRoute } from "./Modules/CheckoutRoute";
import Checkout from "../pages/Checkout/Checkout";
import CheckoutCompleted from "../pages/CheckoutCompleted/CheckoutCompleted";
import CancelReason from "../pages/Cancelation/CancelReason/CancelReason";
import CancelConfirmation from "../pages/Cancelation/CancelConfirmation/CancelConfirmation";
import { MaintenanceProvider } from "../providers/Maintenance/MaintenanceProvider";
import { ChatHighlightsRoute } from "./Modules/ChatHighlightsRoute";
import ChatHighlightsList from "../pages/ChatHighlights/ChatHighlightsList/ChatHighlightsList";
import { DashboardRoute } from "./Modules/DashboardRoute";
import ProductivityDashboardPage from "../pages/Dashboards/ProductivityDashboard";
import AIUsageDashboardPage from "../pages/Dashboards/AIUsageDashboard";
import { SimulationFinancialsRoute } from "./Modules/SimulationFinancialsRoute";
import SimulationFinancialsPage from "../pages/SimulationFinancials";
const RootRoute = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <StyleProvider>
        <AuthProvider>
          <ArticleSearchProvider>
            <AgentsCategoriesProvider>
              <PaginateProvider>
                <SidebarFilterProvider>
                  <UsersProvider>
                    <MaintenanceProvider>
                      <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/authorization">
                          <Route
                            path=":token/:domain"
                            element={<Authorization />}
                          />
                        </Route>
                        <Route path="unauthorized" element={<Unauthorized />} />
                        <Route path="maintenance" element={<Maintenance/>} />
                        <Route path="login-notice" element={<HomeNotice />} />
                        <Route path="*" element={<Page404 />} />

                        {/* Desativado para apenas login via SSO */}
                        {/* <Route path="/login" element={<Login />} /> */}
                        {/* <Route path="/forgotPassword" element={<ForgotPassword />} /> */}
                        {/* <Route path="/reset-password" element={<ResetPassword />} /> */}

                        <Route element={<AuthenticationGate />}>
                          <Route path="/" element={<AppHomeRoute />}>
                            <Route index element={<AppHome />} />
                          </Route>

                          <Route
                            path="/articles/search/:question"
                            element={<ArticlesSearch />}
                          />

                          <Route path="/home" element={<Home />} />
                          <Route path="/categories" element={<Categories />} />

                          <Route path="access" element={<AccessRoute />}>
                            <Route path="access-profiles">
                              <Route
                                path="list"
                                element={<AccessProfilesList />}
                              />
                            </Route>

                            <Route path="access-pages">
                              <Route path="list" element={<AccessPagesList />} />
                            </Route>

                            <Route path="users" element={<UserRoute />}>
                              <Route path="list" element={<UsersList />} />
                            </Route>
                          </Route>

                          <Route path="chats" element={<ChatsRoute />}>
                            <Route path="list" element={<ChatsList />} />
                            <Route path="reply" element={<Chats />} />

                            <Route path="tools">
                              <Route path="list" element={<ChatToolsList />} />
                            </Route>

                            <Route path="messages">
                              <Route
                                path="votes/list"
                                element={<ChatsFeedbackAnalysis />}
                              />
                            </Route>
                            <Route path="tutorial" element={<ChatsTutorial />} />
                          </Route>

                          <Route path="articles" element={<ArticlesRoute />}>
                            <Route path="list" element={<Articles />} />
                            <Route
                              path="view/:id/:chunk_index?"
                              element={<ArticleView />}
                            />

                            <Route path="categories">
                              <Route path="list" element={<AgentsCategories />} />
                              <Route path="view/:id" element={<CategoryView />} />
                            </Route>

                            <Route path="sections">
                              <Route path="list" element={<SectionsArticles />} />
                              <Route path="view/:id" element={<SectionView />} />
                            </Route>

                            <Route path="subsections">
                              <Route
                                path="list"
                                element={<ArticlesSubsectionsList />}
                              />
                              <Route
                                path="view/:id"
                                element={<SubsectionView />}
                              />
                            </Route>
                          </Route>

                          <Route path="profile" element={<CheckoutRoute />}>
                            <Route path="general" element={<General />} />
                            <Route path="account" element={<Account />} />
                            <Route path="privacy" element={<Privacy />} />
                            <Route
                              path="use"
                              element={
                                <UseProvider>
                                  <Use />
                                </UseProvider>
                              }
                            />
                            <Route path="devices" element={<Devices />} />
                          </Route>

                          <Route path="cancelation">
                            <Route path="reason" element={<CancelReason />} />
                            <Route
                              path="confirmation"
                              element={<CancelConfirmation />}
                            />
                          </Route>

                          <Route path="financial" element={<FinancialRoute />}>
                            <Route path="plans" element={<Plans />} />
                            <Route path="coupons" element={<Coupons />} />
                            <Route
                              path="subscriptions"
                              element={<Subscriptions />}
                            />
                            <Route path="payments" element={<Payments />} />
                            <Route path="refunds" element={<Refunds />} />
                          </Route>
                          <Route
                            path="chat-highlight"
                            element={<ChatHighlightsRoute />}
                          >
                            <Route path="list" element={<ChatHighlightsList />} />
                          </Route>

                          <Route path="dashboards" element={<DashboardRoute />}>
                            <Route path="productivity" element={<ProductivityDashboardPage />} />
                            <Route path="ai-usage" element={<AIUsageDashboardPage />} />
                          </Route>

                          <Route path="simulation-financials" element={<SimulationFinancialsRoute />}>
                            <Route path="list" element={<SimulationFinancialsPage />} />
                          </Route>

                          <Route path="pricing" element={<PricingRoute />}>
                            <Route path="list" element={<Pricing />} />
                          </Route>

                          <Route path="checkout" element={<CheckoutRoute />}>
                            <Route path="list" element={<Checkout />} />
                            <Route
                              path="completed/:id"
                              element={<CheckoutCompleted />}
                            />
                          </Route>
                        </Route>
                      </Routes>
                    </MaintenanceProvider>
                    
                  </UsersProvider>
                </SidebarFilterProvider>
              </PaginateProvider>
            </AgentsCategoriesProvider>
          </ArticleSearchProvider>
        </AuthProvider>
      </StyleProvider>
    </BrowserRouter>
  );
};

export default RootRoute;
